import BaseService from '@src/services/BaseService'

class PosService extends BaseService {
    constructor() {
        super('pos')
    }

    deleteMultiple(params) {
        return this.axios.post(`${this.getUrl()}/delete-multiple`, params)
    }
}

export default new PosService()
